import React, { SVGProps } from "react";

const SvgRoof3 = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 350 300" {...props}>
    <path fill="none" d="M0 0h350v300H0z" />
    <g data-name="roof009 dims 1">
      <path
        fill="#afc2cf"
        d="M124.16 203.658v31.002l160.288-92.645v-31.002l-27.516 15.904-14.846-2.784-25.625 26.176-92.301 53.349z"
      />
      <path
        fill="#fff"
        d="M124.16 203.658v31.002l-91.434-52.667v-40.561l41.098-16.66 50.336 78.886z"
      />
      <path
        fill="#afc2cf"
        d="M192.731 199.697v35.052l91.728-52.875v-41.399l-41.963-16.97-49.765 76.192z"
      />
      <path
        fill="#fff"
        d="M192.731 199.697v35.052l-34.234-19.936v-32.802l34.234 17.686z"
      />
      <g fill="#6d9faf">
        <path d="M77.345 144.905v9.223l-7.669-4.417v-9.224l7.669 4.418zM86.738 150.328v9.224l-7.668-4.418v-9.223l7.668 4.417zM77.345 155.951v9.224l-7.669-4.417v-9.224l7.669 4.417zM86.738 161.375v9.223l-7.668-4.417v-9.224l7.668 4.418z" />
      </g>
      <path
        fill="#2072a4"
        d="m293.677 105.559-38.208 22.111-13.871-6.109-15.332 23.009-102.106 59.088-50.801-78.633L243.248 27l50.429 78.559z"
      />
      <path
        fill="#49d8ff"
        d="M243.248 27 73.359 125.025l-49.97 20.215L193.14 47.133 243.248 27z"
      />
      <path
        fill="#22719f"
        d="m158.609 75.836 100.818 49.639 33.584 19.431-49.763-20.1-84.639-48.97z"
      />
      <path
        fill="#48e8ff"
        d="M158.609 75.836v107.908l34.132 19.54 50.507-78.478-84.639-48.97z"
      />
      <g fill="none">
        <path
          stroke="#3f3f3f"
          strokeLinecap="round"
          strokeMiterlimit={10}
          d="M192.731 234.749v-31.091M158.497 214.813l.112-31.069M124.16 234.66v-31.002"
        />
        <path
          stroke="#3f3f3f"
          strokeLinecap="round"
          strokeMiterlimit={10}
          strokeWidth={2}
          d="M284.448 139.56v-28.547"
        />
        <path
          stroke="#002839"
          strokeMiterlimit={10}
          d="M73.709 124.408 243.248 27"
        />
        <path
          stroke="#002839"
          strokeLinejoin="round"
          d="m243.248 124.351-84.639-48.515M258.717 125.79 158.609 75.836v107.908"
        />
        <path
          stroke="#3f3f3f"
          strokeLinecap="round"
          strokeMiterlimit={10}
          strokeWidth={2}
          d="M32.726 141.432v40.561l91.434 52.667 34.337-19.847 34.234 19.936 91.728-52.875v-40.408"
        />
        <path
          stroke="#3b3b3b"
          strokeLinecap="round"
          strokeMiterlimit={10}
          strokeWidth={1.5}
          d="m162.812 252.023 25.935-14.89"
        />
        <path
          stroke="#002839"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="m158.609 183.744-34.449 19.914-50.801-78.633-49.97 20.215L193.14 47.133 243.248 27l50.429 78.559-34.25 19.916 33.584 19.431-49.763-20.1-50.507 78.478-34.132-19.54z"
        />
      </g>
      <g fill="none" stroke="#000" strokeLinejoin="round" opacity={0.25}>
        <path d="m281.505 143.857-2.597 1.502" />
        <path
          strokeDasharray="6.0258 6.0258"
          d="m273.691 148.374-18.259 10.555"
        />
        <path d="m252.823 160.437-2.597 1.501 2.592 1.511" />
        <path
          strokeDasharray="6.14197 6.14197"
          d="m258.125 166.541 18.573 10.824"
        />
        <path d="m279.351 178.911 2.592 1.51" />
      </g>
      <g
        fill="none"
        stroke="#000"
        strokeLinecap="round"
        strokeMiterlimit={10}
        opacity={0.25}
      >
        <path d="M250.226 129.528v3" />
        <path strokeDasharray="7.00896 7.00896" d="M250.226 139.537v10.513" />
        <path d="M250.226 153.555v3" />
      </g>
      <g
        fill="none"
        stroke="#3b3b3b"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={1.5}
      >
        <path d="m101.404 247.809 17.604-10.175M10 195.16l17.561-10.214M14.274 192.67l125.825 72.522" />
      </g>
      <path
        fill="none"
        stroke="#3b3b3b"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={1.5}
        d="m135.807 267.671 17.604-10.175"
      />
      <g
        fill="none"
        stroke="#3b3b3b"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={1.5}
      >
        <path d="m214.969 247.809-17.603-10.175M306.374 195.16l-17.562-10.214" />
      </g>
      <g
        fill="none"
        stroke="#3b3b3b"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={1.5}
      >
        <path d="m180.679 267.356-50.504-29.17M335.818 172.952l-159.431 91.924" />
      </g>
      <path
        fill="none"
        stroke="#3b3b3b"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={1.5}
        d="m340 175.372-43.533-25.145"
      />
      <text
        transform="translate(194.366 267.67)"
        fontSize={16}
        fill="#3b3b3b"
        fontFamily="'Effra Regular', Effra"
      >
        {"C"}
      </text>
      <text
        transform="translate(20.212 121.96)"
        fontSize={16}
        fill="#3b3b3b"
        fontFamily="'Effra Regular', Effra"
      >
        {"P1"}
      </text>
      <text
        transform="translate(304.457 128.422)"
        fontSize={16}
        fill="#3b3b3b"
        fontFamily="'Effra Regular', Effra"
      >
        {"P2"}
      </text>
      <text
        transform="translate(259.196 231.596)"
        fontSize={16}
        fill="#3b3b3b"
        fontFamily="'Effra Regular', Effra"
      >
        {"D"}
      </text>
      <text
        transform="translate(320.444 196.212)"
        fontSize={16}
        fill="#3b3b3b"
        fontFamily="'Effra Regular', Effra"
      >
        {"E"}
      </text>
      <text
        transform="translate(112.926 268.92)"
        fontSize={16}
        fill="#3b3b3b"
        fontFamily="'Effra Regular', Effra"
      >
        {"B"}
      </text>
      <text
        transform="translate(49.78 232.749)"
        fontSize={16}
        fill="#3b3b3b"
        fontFamily="'Effra Regular', Effra"
      >
        {"A"}
      </text>
      <path
        fill="none"
        stroke="#3b3b3b"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={1.5}
        d="M14.279 188.672v8M105.651 241.426v8M140.099 261.315v8M176.385 260.884v8M210.491 241.193v8M301.862 188.441v8M335.897 168.79v8"
      />
      <path
        d="M26.614 143.925C17.303 125.982 11.774 106.58 11.7 89.25"
        fill="none"
        stroke="#3a3b3b"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={1.5}
      />
      <path
        d="M290.716 143.962c9.38-18.056 14.931-37.594 14.947-55.015"
        fill="none"
        stroke="#3b3b3b"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={1.5}
      />
      <path
        fill="none"
        stroke="#3a3b3b"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={1.5}
        d="M68.33 121.924 6.191 86.036"
      />
      <g
        fill="none"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={1.5}
      >
        <path stroke="#3b3b3b" d="m310.916 85.873-21.89 12.638" />
        <path stroke="#fff" d="m289.026 98.511-41.973 24.11" />
      </g>
      <path
        fill="none"
        stroke="#3a3b3b"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={1.5}
        d="m15.175 87.24-6.929 4M27.536 140.067l-1.809 7.793"
      />
      <path
        fill="none"
        stroke="#3b3b3b"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={1.5}
        d="m309.096 90.912-6.928-4M291.752 147.782l-2.078-7.726"
      />
      <text
        transform="rotate(30 -175.573 418.492)"
        fontSize={24}
        fill="#3b3b3b"
        fontFamily="'Effra Regular', Effra"
      >
        {"2"}
      </text>
      <text
        transform="rotate(-30 344.689 -148.676)"
        fontSize={24}
        fontFamily="'Effra Regular', Effra"
      >
        {"1"}
      </text>
    </g>
  </svg>
);

export default SvgRoof3;
